import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@renderer/chat/providers'
import { v1Client } from '@renderer/chat'

interface GoogleCalAttendeesContactsResponse {
  attendees: Array<string>
}

export function useFetchGoogleCalContacts() {
  const { getAuthToken } = useAuth()

  return useQuery({
    queryKey: ['google-cal-fetch-contacts'],
    queryFn: async () => {
      const token = await getAuthToken()

      if (!token) {
        throw new Error('No Highlight token available')
      }

      const response = await v1Client.GET('/connections/google/event-contacts', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      return response.data?.data as GoogleCalAttendeesContactsResponse
    },
  })
}
